// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__nmR-y","content":"ManualTimeModal_content__eHh53"};